module.exports = __webpack_public_path__ + "static/media/9.f06a22f9.jpg";